export default {
  companyName: 'enkel energi ApS',
  companyAddress1: 'Bryghuspladsen 8',
  companyAddress2: '1473 København K',
  phoneShort: '+45 70 60 80 07',
  heroTitle: 'Kontakt os',
  heroSubtitle: 'Har du spørgsmål til vores produkter eller brug for hjælp? Vi er her for at hjælpe dig.',
  heroNote: 'Vi svarer typisk inden for 24 timer',

  // Contact info
  address: 'Adresse',
  phone: 'Telefon',
  email: 'Email',
  openingHours: 'Åbningstider',
  callDuringHours: 'Telefontid: Man-Fre 9-13',
  replyWithin24h: 'Vi besvarer henvendelser Man-Fre 9-17',
  weekdaysPhone: 'Telefon: Man-Fre 9:00–13:00',
  weekdaysEmail: 'Email/henvendelser: Man-Fre 9:00–17:00',
  weekendClosed: 'Lør–søn og helligdage: Lukket',
  holidayHours: 'Jule- og nytårsåbningstider:',
  holiday1: '24.-26. dec: Lukket',
  holiday2: '29.-30. dec: 09:00–12:00',
  holiday3: '31. dec - 2. jan: Lukket',

  // Form
  sendMessage: 'Send os en besked',
  formSubtitle: 'Udfyld formularen, så kontakter vi dig hurtigst muligt',
  name: 'Navn',
  namePlaceholder: 'Dit fulde navn',
  emailPlaceholder: 'din@email.dk',
  phonePlaceholder: '+45 12 34 56 78',
  subject: 'Hvad vil du gerne kontaktes omkring?',
  subjectPlaceholder: 'F.eks. El-aftale, Ladeboks, Solceller...',
  message: 'Besked',
  messagePlaceholder: 'Fortæl os mere om dit ærinde...',
  region: 'Hvor bor du?',
  selectRegion: 'Vælg region...',
  hasEV: 'Har du en elbil i dag?',
  newsletter: 'Ja tak! I må gerne sende mig information og nyhedsbreve om enkel energis produkter.',
  submit: 'Send besked',
  submitting: 'Sender...',
  privacyNote: 'Ved at indsende denne formular accepterer du vores privatlivspolitik.',
  submissionError: 'Der opstod en fejl. Prøv venligst igen eller kontakt os på hej@enkelenergi.dk',

  // Success
  thankDu: 'Tak for din henvendelse!',
  weWillReply: 'Vi vender tilbage til dig hurtigst muligt.',
  sendNewMessage: 'Send en ny besked',

  // Cross-sell
  crossSellTitle: 'Klar til at komme i gang?',
  crossSellSubtitle: 'Se vores produkter og find den løsning der passer til dig',

  // FAQ CTA
  faqCtaTitle: 'Har du brug for hurtig hjælp?',
  faqCtaSubtitle: 'Du finder svar på de mest almindelige spørgsmål på vores FAQ-side',
  goToFaq: 'Gå til FAQ',
};